import React from "react";

const LEVEL_STYLES = {
  "At Risk": "bg-red-500 text-white",
  Developing: "bg-amber-400 text-black",
  Competent: "bg-[#C6F84C] text-black",
  "Best-in-Class": "bg-emerald-400 text-black",
};

export default function LevelBadge({ level, className = "" }) {
  const style = LEVEL_STYLES[level] || LEVEL_STYLES.Competent;
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-widest ${style} ${className}`}
      data-testid="level-badge"
    >
      {level}
    </span>
  );
}
